import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';
import Icon from '../Icon/Icon';
import HoursOfOperationToday from '../HoursOfOperationToday/HoursOfOperationToday';
import { CLOSED_DAY } from '../HoursOfOperationToday/constants';

const HoursOfOperation = (props) => {
  const {
    className = '',
    showHoursIcon = false,
    hideLabel = false,
    hours = {},
    hoursLabel = 'Hours Today',
    showAll = false,
    showToggle = false,
    shouldStartWeekToday = true,
    color = null,
    iconColor = null,
    intlProvider = {},
    abbreviateDays = true,
    closedText = CLOSED_DAY,
    startTimeKey = 'opens',
    endTimeKey = 'closes',
  } = props;

  const hoursLabelDisplay = (!isEmpty(intlProvider)) ? (
    <FormattedMessage id="FFkm1d" description="provider-hours-text" defaultMessage="Hours">
      {txt => <div className="text-sm mr-3 text-text-blue">{`${txt}:`}</div>}
    </FormattedMessage>
  ) : <div className="text-sm mr-3 text-text-blue">{hoursLabel}</div>;


  if (!isEmpty(hours)) {
    return (
      <div className={`flex items-start flex-row ${className}`} style={{ color }}>
        <div className="inline-flex items-center flex-none">
          {showHoursIcon &&
            <Icon
              className="mr-3 inline"
              color={color || iconColor || 'action-blue'}
              icon="Clock"
            />
          }

          {!hideLabel && hoursLabelDisplay}
        </div>

        <HoursOfOperationToday
          hours={hours}
          showAll={showAll}
          showToggle={showToggle}
          abbreviateDays={abbreviateDays}
          closedText={closedText}
          endTimeKey={endTimeKey}
          startTimeKey={startTimeKey}
          shouldStartWeekToday={shouldStartWeekToday}
        />
      </div>
    );
  }

  return null;
};

HoursOfOperation.propTypes = {
  className: PropTypes.string,
  /** display hours Icon next to label */
  showHoursIcon: PropTypes.bool,
  /** hide 'Hours Today' label */
  hideLabel: PropTypes.bool,
  /** hours of operation values to display */
  hours: PropTypes.object,
  /** custom label for hours */
  hoursLabel: PropTypes.string,
  /** should display all days or only the first one */
  showAll: PropTypes.bool,
  /** should display a separate caret to individually toggle hours */
  showToggle: PropTypes.bool,
  /** should start the days of the week on current day */
  shouldStartWeekToday: PropTypes.bool,
  /** color of text */
  color: PropTypes.string,
  /** custom color for icon */
  iconColor: PropTypes.string,
  /** is international provider */
  intlProvider: PropTypes.object,
  /** show abbreviated day labels instead of full day (i.e. `Mon` vs `Monday`) */
  abbreviateDays: PropTypes.bool,
  /** text to display when given day has no hours associated */
  closedText: PropTypes.string,
  /** key for start time in hours object (`{ monday: { opens: '09:00', closes: '17:00' } }`) */
  startTimeKey: PropTypes.string,
  /** key for end time in hours object (`{ monday: { opens: '09:00', closes: '17:00' } }`) */
  endTimeKey: PropTypes.string,
};

export default HoursOfOperation;
